import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiertigacabs() {



  const cardData =
  {
    keyword: ' Pune to Mumbai Ertiga Cab',
    heading: 'Sai Trupti Cabs: Pune to Mumbai Ertiga Cab',
    headingDescription: 'Sai Trupti Cabs offers spacious and comfortable Pune to Mumbai Ertiga cab services, perfect for families, small groups, and business travelers seeking a smooth and affordable ride. Our Maruti Ertiga cars are air-conditioned, well-maintained, and equipped with plush seating and ample luggage space, ensuring a relaxed journey throughout. Whether you’re traveling to Mumbai city, Navi Mumbai, or Mumbai Airport, our professional and background-verified chauffeurs guarantee punctual pickups, courteous service, and safe driving at every step. With transparent fares, flexible one-way and round-trip options, and 24×7 customer support, Sai Trupti Cabs makes intercity travel convenient and enjoyable. Experience the comfort and reliability of Pune to Mumbai travel with Sai Trupti Cabs — your trusted partner for Ertiga cab services.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Pune to Mumbai Ertiga Cab provides spacious and comfortable Maruti Ertiga vehicles for safe and reliable travel between Pune and Mumbai. Perfect for families, groups, and business travelers, this service ensures timely pickups, professional drivers, air-conditioned comfort, ample luggage space, and smooth rides. Additional features include online booking, transparent fares, 24/7 customer support, real-time ride tracking, and flexible travel options for one-way, round trips, or airport transfers."
  },
  {
    "name": "Pune to Mumbai Ertiga Taxi",
    "description": "Pune to Mumbai Ertiga Taxi offers convenient and hassle-free intercity travel with experienced drivers and well-maintained Ertiga vehicles. Passengers can enjoy clean, air-conditioned rides with door-to-door service, transparent pricing, online booking, real-time tracking, 24/7 support, and flexible options for family trips, business travel, or airport commutes."
  },
  {
    "name": "Pune to Mumbai Ertiga Hire",
    "description": "Pune to Mumbai Ertiga Hire provides flexible rental services for those who prefer a self-drive or chauffeur-driven Ertiga. The service guarantees comfort, safety, timely pickups, air-conditioned vehicles, and online booking. Transparent pricing, 24/7 support, and a wide range of rental durations ensure smooth and stress-free intercity travel."
  },
  {
    "name": "Pune to Mumbai Ertiga Rental",
    "description": "Pune to Mumbai Ertiga Rental offers reliable car rental services for travelers seeking spacious and comfortable Ertiga vehicles. Options include self-drive and chauffeur-driven rentals, with features like air-conditioned comfort, professional drivers, flexible rental durations, online booking, real-time ride updates, transparent fares, and 24/7 support for a seamless Pune-Mumbai journey."
  },
  {
    "name": "Pune to Mumbai Ertiga One Way Cab",
    "description": "Pune to Mumbai Ertiga One Way Cab specializes in economical and convenient one-way trips. Passengers enjoy air-conditioned comfort, spacious seating, professional drivers, transparent pricing, online booking, and real-time ride tracking. Ideal for travelers who need a single trip without paying for a return journey, ensuring hassle-free and cost-effective travel."
  },
  {
    "name": "Pune to Mumbai Ertiga Drop",
    "description": "Pune to Mumbai Ertiga Drop offers one-way drop services with experienced drivers familiar with the Pune-Mumbai route. Passengers receive punctual pickups, air-conditioned comfort, spacious seating, professional driving, transparent fares, online booking, and 24/7 support, ensuring safe, timely, and smooth intercity transfers."
  },
  {
    "name": "Affordable Pune to Mumbai Ertiga Cab",
    "description": "Affordable Pune to Mumbai Ertiga Cab provides budget-friendly intercity transport with spacious Maruti Ertiga vehicles. Passengers can enjoy comfort, safety, air-conditioned rides, professional drivers, transparent pricing, online booking, 24/7 support, and flexible travel options, making it ideal for families, students, and cost-conscious travelers."
  },
  {
    "name": "Pune to Mumbai Ertiga Luxury Cab",
    "description": "Pune to Mumbai Ertiga Luxury Cab delivers a premium travel experience in comfortable and elegant Ertiga vehicles. Passengers benefit from air-conditioned interiors, professional chauffeurs, punctual pickups, online booking, transparent fares, real-time ride tracking, 24/7 support, and a smooth, safe, and enjoyable journey between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Ertiga Outstation Cab",
    "description": "Pune to Mumbai Ertiga Outstation Cab offers long-distance intercity travel with spacious and reliable Ertiga vehicles. The service features air-conditioned comfort, professional drivers, transparent pricing, online booking, real-time ride updates, 24/7 customer support, and flexible options for round trips, one-way travel, or group journeys between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Ertiga Airport Taxi",
    "description": "Pune to Mumbai Ertiga Airport Taxi provides dedicated airport transfer services with spacious and comfortable Ertiga vehicles. Passengers enjoy timely pickups, air-conditioned interiors, professional drivers, transparent fares, online booking, real-time tracking, and 24/7 support, ensuring stress-free travel to or from Mumbai airports."
  },
  {
    "name": "Pune to Mumbai Ertiga Online Booking",
    "description": "Pune to Mumbai Ertiga Online Booking allows passengers to reserve Ertiga cabs conveniently through an online platform. Features include instant confirmation, multiple vehicle options, real-time ride tracking, transparent fares, 24/7 customer support, and easy management of bookings for seamless intercity travel between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Ertiga Car Service",
    "description": "Pune to Mumbai Ertiga Car Service provides a professional and reliable intercity travel experience with well-maintained Ertiga vehicles. Services include comfortable seating, air-conditioned interiors, experienced drivers, online booking, transparent pricing, real-time ride tracking, 24/7 support, and flexible travel options for business trips, family travel, or airport transfers."
  },
  {
    "name": "Pune to Mumbai Ertiga AC Cab",
    "description": "Pune to Mumbai Ertiga AC Cab ensures cool and comfortable travel between Pune and Mumbai with fully air-conditioned Ertiga vehicles. Passengers enjoy professional drivers, punctual service, spacious seating, online booking, transparent fares, real-time ride tracking, 24/7 support, and a smooth, reliable journey."
  },
  {
    "name": "Pune to Mumbai Ertiga Sedan Cab",
    "description": "Pune to Mumbai Ertiga Sedan Cab offers hybrid travel options combining the comfort of an Ertiga with features of a sedan. Passengers benefit from spacious seating, air-conditioned interiors, professional drivers, transparent pricing, online booking, real-time ride updates, 24/7 support, and reliable intercity service."
  },
  {
    "name": "Pune to Mumbai Ertiga Travel Service",
    "description": "Pune to Mumbai Ertiga Travel Service provides comprehensive travel solutions including one-way trips, round trips, airport transfers, and group travel with Ertiga vehicles. Passengers enjoy comfortable rides, professional drivers, online booking, transparent fares, real-time tracking, 24/7 support, and a safe, convenient, and enjoyable journey between Pune and Mumbai."
  }
],
"tableData": [
  ["Pune to Mumbai Ertiga Cab", "Pune to Mumbai Ertiga Taxi"],
  ["Pune to Mumbai Ertiga Hire", "Pune to Mumbai Ertiga Rental"],
  ["Pune to Mumbai Ertiga One Way Cab", "Pune to Mumbai Ertiga Drop"],
  ["Affordable Pune to Mumbai Ertiga Cab", "Pune to Mumbai Ertiga Luxury Cab"],
  ["Pune to Mumbai Ertiga Outstation Cab", "Pune to Mumbai Ertiga Airport Taxi"],
  ["Pune to Mumbai Ertiga Online Booking", "Pune to Mumbai Ertiga Car Service"],
  ["Pune to Mumbai Ertiga AC Cab", "Pune to Mumbai Ertiga Sedan Cab"],
  ["Pune to Mumbai Ertiga Travel Service", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Ertiga Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable one‑way cab services from Pune to Mumbai using the spacious 6‑seater Maruti Suzuki Ertiga—perfect for families or groups with luggage."
  },
  {
    "WhyChooseheading": "Reasonable & Transparent Fare",
    "WhyChoosedescription": "We provide clear pricing for the Ertiga from Pune to Mumbai, inclusive of air‑conditioning and major taxes—so you know exactly what you’ll pay."
  },
  {
    "WhyChooseheading": "Ideal Car for the Route",
    "WhyChoosedescription": "The Ertiga is roomy, comfortable for long drives, and well‑suited for the Pune–Mumbai expressway trip—giving you a relaxed journey."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our drivers are courteous, punctual and familiar with the Pune to Mumbai route, ensuring a safe and smooth ride in the Ertiga."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "Pick‑up from anywhere in Pune and drop‑off across Mumbai—whether at the airport, railway station or city address—using the Ertiga for comfort and ease."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "Our Ertiga cars are regularly serviced, sanitized and checked for long‑distance readiness so your journey is smooth and hassle‑free."
  },
  {
    "WhyChooseheading": "24/7 Booking & Support",
    "WhyChoosedescription": "You can book your Pune to Mumbai Ertiga cab around the clock, with our support team ready to assist with anything you need."
  },
  {
    "WhyChooseheading": "Easy Online & Phone Booking",
    "WhyChoosedescription": "Booking your Pune to Mumbai Ertiga cab is simple—via call, WhatsApp or website—with confirmation and prompt dispatch of your vehicle."
  }
]






























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Mumbai Ertiga cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Mumbai Ertiga cab services for one way, round trip, and airport transfers.',
  },
  {
    question: 'How can I book a Pune to Mumbai Ertiga cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Mumbai Ertiga cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What are the features of the Ertiga cab for Pune to Mumbai trips?',
    answer: 'Our Ertiga cabs are spacious, comfortable, and ideal for families or small groups, with ample luggage space and smooth ride quality.',
  },
  {
    question: 'Are the drivers experienced for Pune to Mumbai Ertiga cab trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving on the Pune–Mumbai Expressway, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I book an Ertiga cab for corporate or airport transfers between Pune and Mumbai?',
    answer: 'Certainly. Our Ertiga cab services cater to corporate travel, airport pickups, and personal trips between Pune and Mumbai.',
  },
  {
    question: 'Is the Pune to Mumbai Ertiga cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Ertiga cab services between Pune and Mumbai for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune to Mumbai Ertiga cab fares?',
    answer: 'Our Ertiga cab fares start from ₹2,500 for a one-way Pune to Mumbai trip, depending on the pickup location, time, and additional requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Mumbai Ertiga cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free and secure transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Mumbai Ertiga cabs?',
    answer: 'All Ertiga cabs are sanitized before every trip, and our drivers follow strict hygiene and safety measures for a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Mumbai Ertiga cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Mumbai Ertiga cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'I booked a Pune to Mumbai Ertiga cab with Sai Trupti Cabs. The ride was comfortable, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Sai Trupti Cabs provided excellent service for my Pune to Mumbai trip in an Ertiga cab. Smooth and hassle-free experience!',
    rating: 5,
  },
];


























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Ertiga Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mumbai-ertiga-cab.jpg",
  "description": "Book Pune to Mumbai Ertiga Cab with Sai Trupti Cabs for a comfortable, safe, and affordable journey. Ideal for one-way trips, airport transfers, or outstation travel. Enjoy AC comfort, verified drivers, and 24/7 online booking for Pune to Mumbai Ertiga rides.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15055"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2599",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mumbai-ertiga-cab"
  }
};





  return (
    <div>
      <Helmet>
  <title>Pune to Mumbai Ertiga Cab | Comfortable & Affordable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Ertiga Cab with Sai Trupti Cabs for a comfortable, safe, and affordable journey. Ideal for one-way trips, airport transfers, or outstation travel. Enjoy AC comfort, verified drivers, and 24/7 online booking for Pune to Mumbai Ertiga rides." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Ertiga Cab, Pune to Mumbai Ertiga Taxi, Pune to Mumbai Ertiga Hire, Pune to Mumbai Ertiga Rental, Pune to Mumbai Ertiga One Way Cab, Pune to Mumbai Ertiga Drop, Affordable Pune to Mumbai Ertiga Cab, Pune to Mumbai Ertiga Luxury Cab, Pune to Mumbai Ertiga Outstation Cab, Pune to Mumbai Ertiga Airport Taxi, Pune to Mumbai Ertiga Online Booking, Pune to Mumbai Ertiga Car Service, Pune to Mumbai Ertiga AC Cab, Pune to Mumbai Ertiga Sedan Cab, Pune to Mumbai Ertiga Travel Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiertigacabs;